angular.module('picmonicng').component('picmonicRatingStars', {
  templateUrl: '/templates/app/components/picmonic-rating-stars/picmonic-rating-stars.html',
  bindings: {},
  controller: [
    'LearnService',
    'Picmonics',
    'XpService',
    function (LearnService, Picmonics, XpService) {
      var ctrl = this;
      ctrl.loading = false;
      ctrl.animating = !LearnService.currentCard.user_card_rating;
      ctrl.review = {
        rating: LearnService.currentCard.user_card_rating ? LearnService.currentCard.user_card_rating : 0,
      };

      ctrl.setRating = function (rating) {
        ctrl.review.rating = LearnService.currentCard.user_card_rating = rating;
        ctrl.tempRating = 0;

        if (rating <= 4) {
          LearnService.showReviewModal(rating);
        } else {
          if (!ctrl.loading) {
            ctrl.loading = true;

            ctrl.review.resource = 'reviews';
            ctrl.review.card_id = LearnService.currentCard.card_id;

            Picmonics.save(ctrl.review, function (data) {
              XpService.grant('PicmonicRating', LearnService.currentCard.card_id, angular.element('.audio-time-text'));
            }).$promise.finally(function () {
              ctrl.loading = false;
            });
          }
        }
      };

      ctrl.setTempRating = function (rating) {
        ctrl.tempRating = rating;
      };

      ctrl.resetTempRating = function () {
        ctrl.tempRating = 0;
        ctrl.animating = false;
      };
    },
  ],
});
